import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import moment from "moment"
import 'moment/locale/es';
import ReactPlayer from 'react-player';
import { useWindowSize } from "../helper/Utils";
import Footer from '../components/Footer';
import { useAlert } from "react-alert";
import Report from '../components/Report'
import UpperHeader from '../components/UpperHeader';

export default function NewsDetail() {
    let alert = useAlert();
    const [isMobile, setIsMobile] = useState();

    let size = useWindowSize();

    useEffect(() => {
        getNewsByUUID()

        if (size.width <= 420) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [size.width]);

    let { uuid } = useParams();
    const [newsdata, setnewsdata] = useState([]);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const getNewsByUUID = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getNewsByUUID?uuid=${uuid}`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setnewsdata(data);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener las noticias", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div>
            {newsdata.length && <>
                <UpperHeader child={true} />
                <Header />
                <Report child={true} />
                <div className="text-center p-2">
                    <h2>{newsdata[0].info.title}</h2>
                </div>
                <img src="../linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
                <div className="container-lg">
                    <div className="row p-1">
                        <p className='text-muted'>{moment(newsdata[0].info.createdAt).format("LL")}</p>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Carousel
                                responsive={responsive}
                                renderDotsOutside={true}
                                showDots
                            >
                                {
                                    newsdata[0].images.map((image, index) => {
                                        return <div key={index} className="text-center p-2">
                                            <img src={image.preview} alt="" className='img-fluid' />
                                        </div>
                                    })
                                }
                            </Carousel>
                        </div>
                        <div className="col-md-12 text-justify">
                            <pre>{newsdata[0].info.news}</pre>
                        </div>
                    </div>
                    {newsdata[0].info.link ?
                        ReactPlayer.canPlay(newsdata[0].info.link) ?
                            <div className='headerContainerCalendar text-center pt-5'>
                                <ReactPlayer
                                    className='react-player'
                                    url={`${newsdata[0].info.link}`}
                                    width={isMobile ? '350px' : '750px'}
                                    height={isMobile ? '200px' : '400px'}
                                />
                            </div> : <div className='text-center'>
                                <h3>No se puede reproducir el video, revisa que el link esté correcto</h3>
                            </div>
                        :
                        <></>}
                </div>
                <Footer showmap={false} child={true} />
            </>
            }
        </div>
    )
}
